import styled from 'styled-components';

export const HeroImage = styled.div`
  margin: 0 auto;
  @media (min-width: 577px) {
    width: 80%;
  }
  @media (min-width: 768px) {
    width: 65%;
  }
`;
